export const viewTypes = ['installed', 'enabled', 'disabled', 'online'] as const
export const viewIcons = {
  installed: 'software_installer',
  enabled: 'gears',
  disabled: 'unavailable',
  online: 'online_store',
} as const

export { installOrUpdate } from '@/components/apis/extensionDetail/shared'
